/**
 * Whose a job is, and the one key of the tree whose meaning the software
 * reads. The sign-offs themselves are the tree's (tech-tree spec v3 §8): each
 * placed where the tree puts it, added to a job by hand, holding back what
 * comes after it until it is done, or done on an override with a reason,
 * which stays an open exception until it is cleared.
 */

export const PROCESS_KINDS = ['client', 'internal'] as const;
/** A client's project carries the money axis and the client's sign-offs; an internal one is Jason's own work. */
export type ProcessKind = (typeof PROCESS_KINDS)[number];

/** Permits in hand: what a step held by the permit comes after (core `lockIn`). */
export const PERMIT_KEY = 'permits_in_hand';
